export const clickUpdatePayment = () => ({
  type: 'User clicks to update their payment info',
});
